import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { BadgeCheck, ShieldX, ArrowLeft } from 'lucide-react';
import Logo from '../components/Logo';
import { Seo } from '../components/Seo';
import { api, pictureUrl } from '../lib/api';

const MemberCardVerify = () => {
  const { code } = useParams();
  const [state, setState] = useState({ loading: true, card: null });

  useEffect(() => {
    api.get(`/members/card/${code}`)
      .then(({ data }) => setState({ loading: false, card: data }))
      .catch(() => setState({ loading: false, card: null }));
  }, [code]);

  const { loading, card } = state;
  const pic = pictureUrl(card?.picture);

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6" data-testid="member-card-verify-page">
      <Seo title="Medlemskort | Refuel Weekend" description="Stadfesting av medlemskort for Refuel Weekend 2027." path={`/kort/${code}`} noindex />
      <Logo size="md" />
      <div className="mt-8 w-full max-w-sm rounded-3xl bg-[#0f0a17] border border-white/10 p-8 text-center">
        {loading ? (
          <p className="text-white/60" data-testid="member-card-verify-loading">Sjekkar medlemskort…</p>
        ) : card ? (
          <div data-testid="member-card-verify-valid">
            <BadgeCheck size={56} className="text-emerald-400 mx-auto mb-4" />
            <p className="text-emerald-400 font-bold uppercase tracking-widest text-xs mb-4">Gyldig medlemskort</p>
            {pic ? (
              <img src={pic} alt={card.name} className="w-24 h-24 rounded-full object-cover border-4 border-[#ff2e2e] mx-auto mb-4" />
            ) : (
              <div className="w-24 h-24 rounded-full bg-[#ff2e2e] text-black font-bold text-4xl flex items-center justify-center mx-auto mb-4">{card.name?.[0]?.toUpperCase()}</div>
            )}
            <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "'Oktah Round', sans-serif" }} data-testid="member-card-verify-name">{card.name}</h1>
            <p className="text-white/50 text-[10px] uppercase tracking-[0.25em] font-bold mt-4">Medlemsnummer</p>
            <p className="text-3xl font-bold text-[#ff2e2e] tracking-wider" style={{ fontFamily: "'Oktah Round', sans-serif" }} data-testid="member-card-verify-number">{card.member_number}</p>
            {card.member_since && <p className="text-white/40 text-xs mt-3">Medlem sidan {new Date(card.member_since).toLocaleDateString('nn-NO', { day: 'numeric', month: 'long', year: 'numeric' })}</p>}
          </div>
        ) : (
          <div data-testid="member-card-verify-invalid">
            <ShieldX size={56} className="text-red-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold" style={{ fontFamily: "'Oktah Round', sans-serif" }}>Ugyldig medlemskort</h1>
            <p className="text-white/60 text-sm mt-2">Fann ikkje noko medlemskap for denne koden.</p>
          </div>
        )}
      </div>
      <Link to="/" className="mt-8 inline-flex items-center gap-2 text-white/60 hover:text-white text-sm"><ArrowLeft size={16} /> Til framsida</Link>
    </div>
  );
};

export default MemberCardVerify;
